import { useAuth, overrideConfig } from '@/api/billing-primary'

const fetchInvoiceMonths = function ({ usageAccountId }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/invoice/${usageAccountId}/months`)
}

const fetchInvoiceAnnualSummary = function ({ usageAccountId, year }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/invoice/${usageAccountId}/years/${year}`)
}

export default {
    fetchInvoiceMonths,
    fetchInvoiceAnnualSummary
}
